// temporary id is negative to let backend know it is temporary
let curr = -1
export const getTemporaryId = () => --curr

export const getUid = () => `${+new Date()}`
